import React, {useEffect, useRef} from 'react';
import "./CarouselHome.scss"
import {useTranslation} from "react-i18next";


const CarouselHome = () => {
    const {t, i18n} = useTranslation();

    let contentRef = useRef();
    let current = 0;
    let items = document.querySelectorAll('.item__carousel_home'),
        controls = document.querySelectorAll('.control__carousel_home'),
        headerItems = document.querySelectorAll('.item-header__carousel_home'),
        descriptionItems = document.querySelectorAll('.item-description__carousel_home'),
        activeDelay = .76,
        interval = 5000,
        intervalF = 0;

    const titleCarouselHome1 = [...t('titleCarouselHome1')];
    const titleCarouselHome2 = [...t('titleCarouselHome2')];
    const titleCarouselHome3 = [...t('titleCarouselHome3')];

    const textCarouselHome1 = t('textCarouselHome1').split(' ');
    const textCarouselHome2 = t('textCarouselHome2').split(' ');
    const textCarouselHome3 = t('textCarouselHome3').split(' ');

    const slider = {
        init: () => {
            controls.forEach(control => control.addEventListener('click', (e) => {
                slider.clickedControl(e)
            }));
            controls[current].classList.add('active');
            items[current].classList.add('active');
        },
        nextSlide: () => { // Increment current slide and add active class
            slider.reset();
            if (current === items.length - 1) current = -1; // Check if current slide is last in array
            current++;
            controls[current].classList.add('active');
            items[current].classList.add('active');
            slider.transitionDelay(headerItems);
            slider.transitionDelay(descriptionItems);
        },
        clickedControl: (e) => { // Add active class to clicked control and corresponding slide
            slider.reset();
            clearInterval(intervalF);

            const control = e.target,
                dataIndex = Number(control.dataset.index);

            control.classList.add('active');
            items.forEach((item, index) => {
                if (index === dataIndex) { // Add active class to corresponding slide
                    item.classList.add('active');
                }
            })
            current = dataIndex; // Update current slide
            slider.transitionDelay(headerItems);
            slider.transitionDelay(descriptionItems);
            intervalF = setInterval(slider.nextSlide, interval); // Fire that bad boi back up
        },
        reset: () => { // Remove active classes
            items.forEach(item => item.classList.remove('active'));
            controls.forEach(control => control.classList.remove('active'));
        },
        transitionDelay: (items) => { // Set incrementing css transition-delay for .item-header & .item-description, .vertical-part, b elements
            let seconds;
            items.forEach(item => {
                const children = item.childNodes; // .vertical-part(s)
                let count = 1,
                    delay;
                item.classList.value === 'item-header__carousel_home' ? seconds = .015 : seconds = .007;
                children.forEach(child => { // iterate through .vertical-part(s) and style b element
                    if (child.classList) {
                        item.parentNode.classList.contains('active') ? delay = count * seconds + activeDelay : delay = count * seconds;
                        child.firstElementChild.style.transitionDelay = `${delay}s`; // b element
                        count++;
                    }
                })
            })
        },
    }

    function setInnerHTML(word) {
        return {__html: word};
    }


    useEffect(() => {
        items = contentRef.current.querySelectorAll('.item__carousel_home');
        controls = contentRef.current.querySelectorAll('.control__carousel_home');
        headerItems = contentRef.current.querySelectorAll('.item-header__carousel_home');
        descriptionItems = contentRef.current.querySelectorAll('.item-description__carousel_home');
        intervalF = setInterval(slider.nextSlide, interval);
        slider.init();
    }, []);

    return (
        <div className="content_carousel_home" ref={contentRef}>
            <div className="slideshow_home">
                <div className="slideshow_home--items">
                    <div className="item__carousel_home">
                        <div className="item-image-container__carousel_home">
                            <img className="item-image__carousel_home" src={require('./../assets/images/carouselBgHome2.jpg')}/>
                        </div>
                        <div className="item-header__carousel_home">
                            {titleCarouselHome1.map((char, i) => <span key={i} className="vertical-part__carousel_home"><div className="header__carousel_home">{char}</div></span>)}
                        </div>
                        <div className="item-description__carousel_home">
                            {
                                textCarouselHome1.map(
                                    (word, i) =>
                                        <span key={i} className="vertical-part__carousel_home">
                                           <div dangerouslySetInnerHTML={setInnerHTML(word)}></div>
                                        </span>)
                            }
                        </div>
                    </div>
                    <div className="item__carousel_home">
                        <div className="item-image-container__carousel_home">
                            <img className="item-image__carousel_home" src={require('./../assets/images/carouselBgHome.jpg')}/>
                        </div>
                        <div className="item-header__carousel_home">
                            {titleCarouselHome2.map((char, i) => <span key={i} className="vertical-part__carousel_home"><div className="header__carousel_home">{char}</div></span>)}
                        </div>
                        <div className="item-description__carousel_home">
                            {
                                textCarouselHome2.map(
                                    (word, i) =>
                                        <span key={i} className="vertical-part__carousel_home">
                                            <div dangerouslySetInnerHTML={setInnerHTML(word)}></div>
                                        </span>)
                            }
                        </div>
                    </div>
                    <div className="item__carousel_home">
                        <div className="item-image-container__carousel_home">
                            <img className="item-image__carousel_home" src={require('./../assets/images/carouselBgHome3.jpg')}/>
                        </div>
                        <div className="item-header__carousel_home">
                            {titleCarouselHome3.map((char, i) => <span key={i} className="vertical-part__carousel_home"><div className="header__carousel_home">{char}</div></span>)}
                        </div>
                        <div className="item-description__carousel_home">
                            {
                                textCarouselHome3.map(
                                    (word, i) =>
                                        <span key={i} className="vertical-part__carousel_home">
                                            <div dangerouslySetInnerHTML={setInnerHTML(word)}></div>
                                        </span>)
                            }
                        </div>
                    </div>
                </div>
                <div className="controls__carousel_home">
                    <ul>
                        <li className="control__carousel_home" data-index="0"></li>
                        <li className="control__carousel_home" data-index="1"></li>
                        <li className="control__carousel_home" data-index="2"></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CarouselHome;
